import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Ist dies ein physisches Produkt oder ein digitaler Download?',
  a: 'Dies ist ein 100% digitales Produkt, das im hochwertigen PDF-Format und als bearbeitbare Dateien geliefert wird. Sie können sofort nach dem Kauf von Ihrem Computer, Tablet oder Smartphone darauf zugreifen.'
}, {
  q: 'Ist es für neu qualifizierte Trainer geeignet?',
  a: 'Ja. Das System ist die ideale Grundlage sowohl für neue Trainer, die Struktur und Orientierung benötigen, als auch für erfahrene Coaches, die ihre Zeit optimieren und ihre Kursqualität standardisieren möchten.'
}, {
  q: 'Kann ich es im Personal Training und im Gruppentraining verwenden?',
  a: 'Absolut. Die Frameworks, Workout-Vorlagen und Planungssysteme sind perfekt für Einzeltraining, Kleingruppentraining, Großgruppen-Klassen und Studio-Betrieb anpassbar.'
}, {
  q: 'Deckt es verschiedene Trainingsziele und Levels ab?',
  a: 'Ja. Das System enthält Materialien für die häufigsten Trainingsziele: Gewichtsverlust, Kraftaufbau, athletische Leistung, allgemeine Fitness, Conditioning, Mobilität und Rehabilitation.'
}, {
  q: 'Wie schnell werde ich die Vorteile bemerken?',
  a: 'Die meisten Trainer berichten, dass sie sich bereits am ersten Tag der Implementierung deutlich organisierter und sicherer fühlen, bevor sie eine Einheit beginnen.'
}, {
  q: 'Erhalte ich die 5 Premium-Boni sofort?',
  a: 'Ja. Alle 5 Premium-Boni – Class Idea Generator™, Warm-Up Builder Pack™, Coaching Cues Cheat Sheet™, Equipment Switch Guide™ und 7-Day Planning Sprint™ – sind im Kauf enthalten und werden sofort zusammen mit dem Hauptsystem geliefert.'
}, {
  q: 'Brauche ich spezielles Equipment, um das System zu nutzen?',
  a: 'Nein. Die Übungen und Vorlagen decken alle Equipment-Stufen ab – von reinem Körpergewicht bis zu Kurzhanteln, Kettlebells, Bändern und mehr. Der Equipment Switch Guide™ hilft Ihnen, jede Einheit sofort anzupassen, wenn Equipment fehlt.'
}, {
  q: 'Funktioniert das System auch für Online- und Remote-Coaching?',
  a: 'Ja. Die Workout-Vorlagen, Progressionsprogramme und Coaching-Tools eignen sich perfekt für Online- und Remote-Coaching. Tracking-Sheets und Zielblätter lassen sich problemlos digital mit Ihren Kunden teilen.'
}, {
  q: 'Ist es eine einmalige Zahlung oder ein Abonnement?',
  a: 'Eine einmalige Zahlung. Sie zahlen 37 € einmal und erhalten lebenslangen Zugang zum gesamten Functional Trainer System™, allen 6 Modulen, allen 5 Boni und zukünftigen Updates. Keine wiederkehrenden Kosten, keine versteckten Gebühren.'
}, {
  q: 'Wie funktioniert die Geld-zurück-Garantie?',
  a: 'Schreiben Sie uns einfach innerhalb von 7 Tagen nach dem Kauf eine E-Mail und wir erstatten Ihnen sofort den vollen Betrag. Keine Fragen, keine Komplikationen. Wir stehen zu 100% hinter dem System.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-10 px-4 bg-brand-cream" data-id="element-37">
      <div className="max-w-3xl mx-auto" data-id="element-38">
        <div className="text-center mb-5" data-id="element-39">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-brand-graphite mb-1" data-id="element-40">
            HÄUFIG GESTELLTE FRAGEN
          </h2>
          <p className="text-base text-brand-graphite/70" data-id="element-41">
            Antworten auf Ihre Fragen
          </p>
        </div>

        <div className="space-y-3" data-id="element-42">
          {faqs.map((faq, i) => <div key={i} className="bg-white border-2 border-brand-gold/40 rounded-lg overflow-hidden" data-id="element-43">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-brand-cream/50 transition-colors gap-4" data-id="element-44">
                <span className="font-bold text-brand-graphite text-base" data-id="element-45">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-petrol transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-46" />
              </button>

              {openIndex === i && <div className="px-5 pb-4 pt-0 text-brand-graphite/80 leading-relaxed" data-id="element-47">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}